import { useContext, useEffect, useMemo } from 'react';
import { TagGeneratingFilesContext } from '@trinity/chat-components/containers/Workspace/context.js';
import { CanUploadFilesContext, UploadFilesContext } from '@trinity/chat-components/containers/WorkspaceFileUpload/Context.js';
import { useInitiateFilesReview } from '@trinity/chat-components/containers/WorkspaceFileUpload/hooks/useInitiateFilesReview.js';
import { useQueryParams } from 'use-query-params';
import { BrandStateContext } from '@/containers/Workspace.Brand/Context';
import { WorkspaceObjectType } from '@/enums';
import WS from '@/enums/workspace';
import { useFileTagsEvents } from '@/hooks/useFileTagsEvents';
import {
  FilesTableContext,
  FilesTableDataContext,
  SetFilesTableFiltersContext,
  FilesTableFiltersContext,
  FilesTableLoadingContext,
  SelectedObjectsContainer,
} from '@/screens/Workspace.FilesTable';
import { useFetchObjectChildrenQuery } from './hooks/useFetchObjectChildrenQuery';

type Props = ChildrenProps;

const useParams = () => {
  return useQueryParams({

  });
};

export const BrandFilesContainer = (props: Props) => {
  const [params, setQueryParams] = useParams();

  const state = useContext(BrandStateContext);

  const uploadFiles = useInitiateFilesReview({
    parentObjectId: state.object.id,
    workspaceId: state.object.workspaceId,
  });

  const query = useFetchObjectChildrenQuery({
    objectId: state.object.id,
    workspaceId: state.object.workspaceId,
    // filters: {
    //   typeIds: WS.WorkspaceObjectType.values().filter(ot => ot !== WorkspaceObjectType.ProjectParent),
    //   ...params,
    // },
  });

  const tagGeneratingContext = useContext(TagGeneratingFilesContext);

  // Get list of files currently generating tags
  const generatingFileIds = useMemo(() => {
    return Array.from(tagGeneratingContext?.generatingFileIds || []);
  }, [tagGeneratingContext?.generatingFileIds]);

  // Subscribe to WebSocket events for generating files
  useFileTagsEvents(generatingFileIds);

  // Remove files from generating state when tags appear in the data
  // This is a fallback in case WebSocket events don't fire or are missed
  useEffect(() => {
    if (!tagGeneratingContext || !query.data?.items) return;

    const items = query.data.items;
    items.forEach(item => {
      const isFileItem = 'file' in item && item.file !== null;
      if (isFileItem && item.file && tagGeneratingContext.isGenerating(item.file.id) && item.tags && item.tags.length > 0) {
        tagGeneratingContext.removeGeneratingFile(item.file.id);
      }
    });
  }, [query.data?.items, tagGeneratingContext]);

  return (
    <SelectedObjectsContainer>
      <FilesTableDataContext.Provider value={query.data?.items || []}>
        <FilesTableLoadingContext.Provider value={query.isLoading}>
          <FilesTableFiltersContext.Provider value={params}>
            <SetFilesTableFiltersContext.Provider value={setQueryParams}>
              <FilesTableContext.Provider value={{ parentObject: state.object }}>
                <UploadFilesContext.Provider value={uploadFiles}>
                  <CanUploadFilesContext.Provider value={state.capabilities.canAddChildren}>
                    {props.children}
                  </CanUploadFilesContext.Provider>
                </UploadFilesContext.Provider>
              </FilesTableContext.Provider>
            </SetFilesTableFiltersContext.Provider>
          </FilesTableFiltersContext.Provider>
        </FilesTableLoadingContext.Provider>
      </FilesTableDataContext.Provider>
    </SelectedObjectsContainer>
  );
};